export const userEntities = {
    ORGANIZATION: "Organization",
    INDIVIDUAL: "Individual",
    INVITEE: "invitee",
    DEFAULT: "default",
};

export const userPreferenceTypes = {
    FEATURE_RELEASE: "FEATURE_RELEASE",
    WEEKLY_SUMMARY: "WEEKLY_SUMMARY",
    COMMENTS_AND_MESSAGES: "COMMENTS_AND_MESSAGES",
};

export const userPreferenceCommunicationTypes = {
    EMAIL: "EMAIL",
};

export const userRoles = {
    OWNER: "owner",
    MEMBER: "member",
};
